import React from 'react';
import Projectcard from './Projectcard';
import evoke from '../images/evoke.png';
import loanplus from '../images/finology/Loanplus.png'
import creditwidget from '../images/finology/creditwidget.png'
import Loanstreet from '../images/finology/Loanstreet.png'
import heypeers from '../images/heypeers.png';
import highschoolzoom from '../images/highschoolzoom.png'
import angelelectronicfront from '../images/angelelectronicfront.png'
import angelelectronicback from '../images/angelelectronicback.png'
import qualityenterprise from '../images/qualityenterprise.png'


 export default function Project() {
  return (
    <div className="wrapper" id="project">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2 className="heading">Projects</h2>
            <div className="row mt-5">
              <Projectcard icon={loanplus} link={"https://loanplus.io"} des={"A Finance solution, Pre process user loan application & forward to a bank. LP has 18 registered banks of Malaysia."} name={"Loanplus - Finology"}/>
              <Projectcard icon={creditwidget} link={"https://creditwidget.finology.com.my"} des={"A Finance tool, Clients/Users check loan eligibility & apply for loan. It has two sub widget (one check loan eligibility only and other check eligibility & let user apply for loan)."} name={"Credit Widget - Finology"}/>
              <Projectcard icon={Loanstreet} link={"https://loanstreet.com.my"} des={"A Finance solution, Support online loan applications, Car & Motorcycle insurance and guiding articles."} name={"Loanstreet - Finology"}/>
              <Projectcard icon={heypeers} link={"https://heypeers.com/"} des={"A Medical solution, for collaboration of Peers. Organization & Peer Supporters can business on HeyPeers."} name={"HeyPeers"}/>
              <Projectcard icon={evoke}  link={"https://evoke.team/"} des={"A website of fast growing Startup of Pakistan, Punjab, Lahore."} name={"Evoke Team"}/>
              <Projectcard icon={highschoolzoom} link={"https://highschoolzoom.com/"} des={"A solution for monitoring & participating remotely in school events of their childrens."} name={"High School Zoom"}/>
              <Projectcard icon={angelelectronicfront} link={"http://138.197.149.251/"} des={"E-commerce solution with dual currency (USD, CAD), Shipping Services and payment gateway."} name={"Angel Electronic"}/>
              <Projectcard icon={angelelectronicback} link={"http://138.197.149.251:81/"} des={"Admin panel to manage Products, Categories, News, Taxes, Coupons, Orders, Blogs and reports."} name={"Angel Electronic Admin Panel"}/>
              <Projectcard icon={qualityenterprise} link={"#"} des={"Quality Enterprise is a POS (point of sale) solution."} name={"Quality Enterprise (POS)"}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}